export const ADD_CONTENT_MENU = [
  {
    key: 'text',
    label: 'Text',
    children: [
      { type: 'text_large_heading', label: 'Large heading' },
      { type: 'text_small_heading', label: 'Small heading' },
      { type: 'text_body', label: 'Body' },
      { type: 'text_caption', label: 'Caption' },
    ],
  },
  {
    key: 'media',
    label: 'Media',
    children: [{ type: 'image', label: 'Image' }],
  },
  {
    key: 'text_answer',
    label: 'Text Answer',
    children: [
      { type: 'text_input', label: 'Short answer' },
      { type: 'text_area', label: 'Paragraph' },
      { type: 'date_picker', label: 'Date picker' },
    ],
  },
  {
    key: 'selection',
    label: 'Selection',
    children: [
      { type: 'navigation_list', label: 'Navigation list' },
      { type: 'radio', label: 'Single choice' },
      { type: 'checkbox', label: 'Multiple choice' },
      { type: 'dropdown', label: 'Dropdown' },
      { type: 'opt_in', label: 'Opt-in' },
    ],
  },
  {
    key: 'button',
    label: 'Button',
    children: [{ type: 'button', label: 'Continue / Footer' }],
  },
];

export const COMPONENT_LABELS = {
  text_large_heading: 'Large heading',
  text_small_heading: 'Small heading',
  text_body: 'Body',
  text_caption: 'Caption',
  text_input: 'Short answer',
  text_area: 'Paragraph',
  text_email: 'Email',
  text_phone: 'Phone',
  image: 'Image',
  navigation_list: 'Navigation list',
  radio: 'Single choice',
  checkbox: 'Multiple choice',
  dropdown: 'Dropdown',
  date_picker: 'Date picker',
  opt_in: 'Opt-in',
  button: 'Button',
};

export const slugifyScreenId = (title, index = 0) => {
  const base = (title || `screen_${index + 1}`)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 50);
  return base || `screen_${index + 1}`;
};

const uniqueName = (prefix, index) => `${prefix}_${Date.now()}_${index}`;

export const createComponent = (type) => {
  const id = uniqueName('field', Math.floor(Math.random() * 1000));

  switch (type) {
    case 'text_large_heading':
      return { id, type, text: 'Large heading', max_length: 80 };
    case 'text_small_heading':
      return { id, type, text: 'Small heading', max_length: 80 };
    case 'text_body':
      return { id, type, text: 'Body text', max_length: 4096 };
    case 'text_caption':
      return { id, type, text: 'Caption text', max_length: 4096 };
    case 'text_input':
      return {
        id,
        type,
        name: id,
        placeholder: 'Short answer',
        required: true,
        max_length: 120,
      };
    case 'text_area':
      return {
        id,
        type,
        name: id,
        label: 'Leave a comment',
        required: false,
        max_length: 600,
      };
    case 'text_email':
      return {
        id,
        type,
        name: id,
        placeholder: 'Email address',
        required: true,
      };
    case 'text_phone':
      return {
        id,
        type,
        name: id,
        placeholder: 'Phone number',
        required: true,
      };
    case 'image':
      return { id, type, src: '', alt: 'Image' };
    case 'navigation_list':
      return {
        id,
        type,
        name: id,
        label: 'Select an option',
        data_mode: 'dynamic',
        data_source_key: 'items',
        payload_key: 'item_id',
        click_action: 'data_exchange',
        example_items: [
          {
            id: 'item_1',
            title: 'Sample item',
            description: 'Tap to select',
            image_src: '',
            image_alt: 'Item',
          },
        ],
      };
    case 'radio':
      return {
        id,
        type,
        name: id,
        label: 'Choose one',
        required: true,
        data_mode: 'static',
        data_source_key: 'options',
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ],
      };
    case 'checkbox':
      return {
        id,
        type,
        name: id,
        label: 'Select options',
        required: false,
        data_mode: 'static',
        data_source_key: 'options',
        options: [{ value: 'option_1', label: 'Option 1' }],
      };
    case 'dropdown':
      return {
        id,
        type,
        name: id,
        label: 'Select option',
        required: true,
        data_mode: 'static',
        data_source_key: 'options',
        options: [
          { value: 'option_1', label: 'Option 1' },
          { value: 'option_2', label: 'Option 2' },
        ],
      };
    case 'date_picker':
      return {
        id,
        type,
        name: id,
        label: 'Select date',
        required: true,
      };
    case 'opt_in':
      return {
        id,
        type,
        name: id,
        label: 'I agree to the terms',
        required: true,
      };
    case 'button':
      return {
        id,
        type,
        name: id,
        label: 'Continue',
        action: 'data_exchange',
        payload_keys: [],
      };
    default:
      return { id, type: 'text_body', text: 'Text', max_length: 4096 };
  }
};

export const createScreen = (title, index = 0) => {
  const screenTitle = title || `Screen ${index + 1}`;
  return {
    id: slugifyScreenId(screenTitle, index),
    title: screenTitle,
    components: [createComponent('button')],
  };
};

export const getComponentSummary = (component) => {
  if (!component) return '';
  switch (component.type) {
    case 'text_large_heading':
    case 'text_small_heading':
    case 'text_body':
    case 'text_caption':
      return component.text || COMPONENT_LABELS[component.type];
    case 'text_input':
    case 'text_email':
    case 'text_phone':
      return component.placeholder || component.label || COMPONENT_LABELS[component.type];
    case 'text_area':
    case 'navigation_list':
      if (component.data_mode === 'dynamic') {
        return `${component.label || 'List'} · API: ${component.data_source_key || 'items'}`;
      }
      return component.label || COMPONENT_LABELS[component.type];
    case 'radio':
    case 'checkbox':
    case 'dropdown':
      if (component.data_mode === 'dynamic') {
        const label =
          component.type === 'radio'
            ? 'Single choice'
            : component.type === 'checkbox'
              ? 'Multiple choice'
              : 'Dropdown';
        return `${component.label || label} · API: ${component.data_source_key || 'options'}`;
      }
      return component.label || COMPONENT_LABELS[component.type];
    case 'date_picker':
    case 'opt_in':
      return component.label || COMPONENT_LABELS[component.type];
    case 'button':
      return component.label || 'Continue';
    case 'image':
      return component.alt || 'Image';
    default:
      return COMPONENT_LABELS[component.type] || component.type;
  }
};

/** Components that support "From API (dynamic)" in the builder. */
export const DYNAMIC_DATA_COMPONENT_TYPES = ['navigation_list', 'radio', 'checkbox', 'dropdown'];

/**
 * Example endpoint response Meta expects when data_mode is dynamic.
 * Tenant maps their DB fields into this shape before returning.
 */
export const buildDynamicApiResponseExample = (componentType, dataSourceKey = 'items') => {
  const key = (dataSourceKey || 'items').trim() || 'items';

  if (componentType === 'navigation_list') {
    return {
      version: '3.0',
      screen: 'YOUR_SCREEN_ID',
      data: {
        [key]: [
          {
            id: '1',
            'main-content': {
              title: 'Item title',
              description: 'Optional subtitle',
            },
            start: {
              image: 'BASE64_JPEG_OR_PNG_UNDER_100KB',
              'alt-text': 'Item title',
            },
            // Optional: Waba injects this at runtime with the real id if omitted.
            'on-click-action': {
              name: 'data_exchange',
              payload: { item_id: '1' },
            },
          },
        ],
      },
    };
  }

  if (componentType === 'radio' || componentType === 'checkbox' || componentType === 'dropdown') {
    return {
      version: '3.0',
      screen: 'YOUR_SCREEN_ID',
      data: {
        [key]: [
          { id: '1', title: 'Option label' },
          { id: '2', title: 'Another option' },
        ],
      },
    };
  }

  return null;
};

export const getDynamicApiSchemaHint = (componentType) => {
  if (componentType === 'navigation_list') {
    return 'Use main-content.title (max 30 chars) and optional description (max 20). Images go in start.image as base64 JPEG/PNG under 100KB. Waba adds per-item on-click-action with the real id so the next screen URL can use {item_id}.';
  }
  if (componentType === 'radio' || componentType === 'checkbox' || componentType === 'dropdown') {
    return 'Each option needs id and title. Map your API fields on the tenant endpoint.';
  }
  return '';
};

export const screenHasDynamicFields = (screen) =>
  (screen?.components || []).some(
    (component) =>
      component.data_mode === 'dynamic' && DYNAMIC_DATA_COMPONENT_TYPES.includes(component.type)
  );

export const buildScreenDynamicApiResponseExample = (screen) => {
  const dynamicComponents = (screen?.components || []).filter(
    (component) =>
      component.data_mode === 'dynamic' && DYNAMIC_DATA_COMPONENT_TYPES.includes(component.type)
  );

  if (!dynamicComponents.length) {
    return null;
  }

  const data = {};
  dynamicComponents.forEach((component) => {
    const example = buildDynamicApiResponseExample(
      component.type,
      component.data_source_key || 'items'
    );
    if (example?.data) {
      Object.assign(data, example.data);
    }
  });

  return {
    version: '3.0',
    screen: (screen.id || 'YOUR_SCREEN_ID').toUpperCase(),
    data,
  };
};

export const buildScreenEndpointsPayload = (screens = []) => {
  const endpoints = {};

  screens.forEach((screen) => {
    if (screen.tenant_api_uri?.trim()) {
      endpoints[screen.id] = screen.tenant_api_uri.trim();
    }
  });

  return Object.keys(endpoints).length ? endpoints : null;
};

/**
 * Payload keys available from screens before `screenId`
 * (Navigation list "Payload key on tap", footer payload keys, form field names).
 */
export const getPreviousPayloadKeys = (screens = [], screenId) => {
  const index = screens.findIndex((screen) => screen.id === screenId);
  if (index <= 0) {
    return [];
  }

  const keys = [];
  for (let i = 0; i < index; i += 1) {
    const components = screens[i]?.components || [];
    components.forEach((component) => {
      if (component.type === 'navigation_list' && component.payload_key?.trim()) {
        keys.push(component.payload_key.trim());
      }
      if (component.type === 'button' && Array.isArray(component.payload_keys)) {
        component.payload_keys.forEach((entry) => {
          if (entry?.payload_key?.trim()) {
            keys.push(entry.payload_key.trim());
          }
        });
      }
      if (
        ['radio', 'checkbox', 'dropdown', 'text_input', 'text_area', 'text_email', 'text_phone', 'date_picker', 'opt_in'].includes(
          component.type
        ) &&
        component.name?.trim()
      ) {
        keys.push(component.name.trim());
      }
    });
  }

  return [...new Set(keys)];
};

export const mergeScreenEndpoints = (screens = [], screenEndpoints = {}) =>
  screens.map((screen) => ({
    ...screen,
    tenant_api_uri:
      screenEndpoints[screen.id] ||
      screenEndpoints[screen.id?.toUpperCase()] ||
      screen.tenant_api_uri ||
      '',
  }));
